<!--
	日期：2025/09/25
	地点：四川 成都
	作者：终结司令官
	
	介绍：我的个人信息修改
	
	- Powered by finalcommander.com
	- Supported by IOE.TOP
-->
<template>
	<div id="app-readlegalnotice" class="app-readlegalnotice">
	<myLegalNotice :mln_id="'forreg'" :mini-show="true"></myLegalNotice>
	</div>
</template>

<script>
import myLegalNotice from '../components/LegalNotice.vue'
import { getQuery, getDownloadURL } from '../api/'
export default {
	name: 'app-readlegalnotice',
	components: {
		myLegalNotice,
	},
	data() { return {
	}},
	state: {
	},
	mounted() {
	},
	methods: {
	},
	computed: {
	},
	mutations: {
	}
}
</script>

<style lang="less" Scoped>
.app-readlegalnotice {
  padding: 5px;

}
</style>